export default __webpack_public_path__ + "static/media/diamond-wheel.8bd867b4.png";